// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1qaEX","ranges":"BmiRanges_ranges__3l4uU"};